'use client';

import { c as _c } from "react/compiler-runtime";
import type { GetPositionsRow } from '@morfi/backend-sdk-v2/client';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { Badge } from '@/components/ui/app-badge';
import { StatusPill } from '@/components/ui/status-pill';
export function PortfolioPositionResultBadge(t0) {
  const $ = _c(12);
  const {
    resultState
  } = t0;
  const t = useTranslations("profile.stats.positions");
  switch (resultState) {
    case "won_holding":
    case "won_sold":
      {
        let t1;
        if ($[0] !== t) {
          t1 = t("resultWon");
          $[0] = t;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        let t2;
        if ($[2] !== t1) {
          t2 = <StatusPill tone="success" size="xs">{t1}</StatusPill>;
          $[2] = t1;
          $[3] = t2;
        } else {
          t2 = $[3];
        }
        return t2;
      }
    case "lost":
      {
        let t1;
        if ($[4] !== t) {
          t1 = t("pillLost");
          $[4] = t;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        let t2;
        if ($[6] !== t1) {
          t2 = <StatusPill tone="destructive" size="xs">{t1}</StatusPill>;
          $[6] = t1;
          $[7] = t2;
        } else {
          t2 = $[7];
        }
        return t2;
      }
    case "sold_out":
      {
        let t1;
        if ($[8] !== t) {
          t1 = t("resultSold");
          $[8] = t;
          $[9] = t1;
        } else {
          t1 = $[9];
        }
        let t2;
        if ($[10] !== t1) {
          t2 = <Badge variant="secondary">{t1}</Badge>;
          $[10] = t1;
          $[11] = t2;
        } else {
          t2 = $[11];
        }
        return t2;
      }
    case "open":
      {
        return null;
      }
  }
}